import { useEffect, useState } from "react";

export const useBestFaresIframeHeight = () => {
	const [height, setHeight] = useState(0);

	useEffect(() => {
		window.addEventListener("message", otrlWidgetResize, false);

		function otrlWidgetResize(event) {
			if (event.data.event === "fare-finder:resize") {
				setHeight(event.data.height);
			}
		}
	}, []);

	return { bestFaresIframeHeight: height }
}
